// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".0be7f796ef4b278e6ba4929efaab95e0.js";
};